import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import { api } from "@/lib/api";

const KIND_LABEL = {
  department_complete: "Department complete", department_reopened: "Reopened by GM", gm_override: "GM changed figures", capex_override: "CAPEX updated by GM",
  capex_proposed: "CAPEX approval needed", capex_approved: "CAPEX approved", capex_rejected: "CAPEX rejected", deadline_set: "Deadline set",
  deadline_reminder: "Deadline reminder", deadline_overdue: "Overdue", deadline_summary: "Overdue summary",
};
const KIND_CLS = { capex_rejected: "text-red-700", deadline_overdue: "text-red-700", deadline_summary: "text-red-700", capex_approved: "text-emerald-700", capex_proposed: "text-amber-700", deadline_reminder: "text-amber-700" };

export const NotificationsBell = () => {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const h = setInterval(load, 60000); return () => clearInterval(h); }, []);
  const markAll = async () => { await api.post("/notifications/read").catch(() => {}); setData((d) => ({ items: d.items.map((n) => ({ ...n, read: true })), unread: 0 })); };
  const go = (n) => {
    setOpen(false);
    if (!n.read) markAll();
    if (n.link) navigate(n.link.replace(/^https?:\/\/[^/]+/, ""));
  };
  return (
    <div className="relative">
      <button type="button" onClick={() => setOpen((o) => !o)} className="relative p-2 rounded-md text-slate-600 hover:text-emerald-700 hover:bg-slate-100" data-testid="notifications-bell" aria-label="Notifications">
        <Bell size={17} />
        {data.unread > 0 && <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-amber-400 text-slate-900 text-[10px] font-bold flex items-center justify-center" data-testid="notifications-unread">{data.unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-[22rem] max-w-[92vw] max-h-[70vh] overflow-y-auto rounded-lg border border-slate-200 bg-white shadow-xl z-50 text-slate-800" data-testid="notifications-panel">
          <div className="flex items-center justify-between px-3 py-2 border-b border-slate-100">
            <p className="text-[10px] uppercase tracking-wider text-slate-500">Notifications</p>
            {data.unread > 0 && <button type="button" onClick={markAll} className="text-[10px] text-emerald-700 hover:underline inline-flex items-center gap-1" data-testid="notifications-mark-read"><CheckCheck size={11} /> Mark all read</button>}
          </div>
          {data.items.length === 0 && <p className="px-3 py-4 text-xs text-slate-500">No notifications yet.</p>}
          {data.items.map((n, i) => (
            <button key={n.id} type="button" onClick={() => go(n)} className={`block w-full text-left px-3 py-2 text-xs border-b border-slate-50 hover:bg-slate-50 ${n.read ? "text-slate-600" : "text-slate-900 font-medium bg-amber-50/40"}`} data-testid={`notification-item-${i}`}>
              <span className={`block text-[10px] uppercase tracking-wider ${KIND_CLS[n.kind] || "text-slate-500"}`}>{KIND_LABEL[n.kind] || n.kind}</span>
              {n.message}<span className="block text-[10px] text-slate-400 mt-0.5">{(n.created_at || "").slice(0, 16).replace("T", " ")}{n.link ? " · open" : ""}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
